<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table fixed-header height= "70vh"  :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100" show-select item-key="ID" v-model="selectedList">
                    <template v-slot:item="{ item, isSelected, select }">
                        <tr :id="'r-' + item.ID" :active="isSelected">
                            <td @click="select(!isSelected)"><v-checkbox primary hide-details :input-value="isSelected"></v-checkbox></td>
                            <td>{{ item.OrderTransactionCode }}</td>
                            <td>{{ item.OrderCodeCN }}</td>
                            <td>{{ (item.PackageType === 1 ? 'KG' : '') + item.OrderID }}</td>
                            <!-- <td>{{ item.PackageCode }}</td> -->
                            <td>{{ item.ExportReceiptID }}</td>
                            <td>{{ item.Username }}</td>
                            <td class="text-right" v-if="weightEditable && item.Status != 4">
                                <v-edit-dialog :return-value.sync="item.Volume" large lazy persistent @save="saveItem({ID: item.ID, Volume: item.Volume, Length: item.Length, Width: item.Width, Height: item.Height})">
                                <div>
                                    {{ item.Volume | currency('', 2) }} ({{ item.Length | currency }}x{{ item.Width | currency }}x{{ item.Height | currency }})
                                </div>
                                <template v-slot:input>
                                    <v-text-field v-model="item.Length" type="number" step="1" label="Chiều dài" :disabled="item.Status == package_status_enum.KH_DA_NHAN" single-line autofocus></v-text-field>
                                    <v-text-field v-model="item.Width" type="number" step="1" label="Chiều rộng" :disabled="item.Status == package_status_enum.KH_DA_NHAN" single-line autofocus></v-text-field>
                                    <v-text-field v-model="item.Height" type="number" step="1" label="Chiều cao" :disabled="item.Status == package_status_enum.KH_DA_NHAN" single-line autofocus></v-text-field>
                                </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-right" v-else>
                                {{ item.Volume | currency('', 2) }} ({{ item.Length | currency }}x{{ item.Width | currency }}x{{ item.Height | currency }})
                            </td>
                            <td class="text-right" v-if="weightEditable && item.Status != 4">
                                <v-edit-dialog :return-value.sync="item.Weight" large lazy persistent @save="saveItem({ID: item.ID, Weight: item.Weight})">
                                <div>{{ item.Weight | currency('', 1) }}</div>
                                <template v-slot:input>
                                    <v-text-field v-model="item.Weight" type="number" step=".1" label="Cân nặng" :disabled="item.Status == package_status_enum.KH_DA_NHAN" single-line autofocus></v-text-field>
                                </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-right" v-else>{{ item.Weight | currency('', 1) }}</td>
                            <td v-bind:style="{ 'color': get_status_color(item.Status, package_status)}">
                                <v-edit-dialog :return-value.sync="item.Status" large lazy persistent @save="saveItem({ID: item.ID, Status: item.Status})">
                                    <div>{{ item.Status | display_value(package_status) }}</div>
                                    <template v-slot:input>
                                        <v-select v-model="item.Status" :items="package_status" label="Trạng thái" item-text="name" item-value="value" :disabled="item.Status == package_status_enum.KH_DA_NHAN" single-line autofocus></v-select>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td>{{ item.CreatedDate | display_date }}</td>
                            <td class="text-center">
                                <v-icon v-if="moduleRole & 4096" medium class="mr-2" @click="gotoDetail(item.PackageType, item.OrderID, item.UID)">visibility</v-icon>
                                <v-icon medium class="mr-2" color="red darken-2" @click="printTransaction(item.Weight, item.OrderTransactionCode, item.Username, item.OrderID, item.NumberOfCode)">print</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
    <v-dialog v-model="showDialogTrancode" max-width="300px">
      <v-card>
        <v-card-title>
          <span class="title">Mã vận đơn</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <v-text-field label="Mã vận đơn" v-model="newTransactionCode" @change="saveNewTrancode(false)"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="showDialogTrancode = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="saveNewTrancode">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import {
    mapState
} from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import { print_transaction } from "@/commons/hpod";
import { sendErrorNotice } from "@/commons/utils";
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            selectedList: [],
            package_status: configs.PACKAGE_STATUS,
            package_status_enum: configs.PACKAGE_STATUS_ENUM,
            pagination: _.cloneDeep(configs.PAGINATION),
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "transactioncode_list",
            filterConditions: [],
            quickFilterConditions: [],
            showDialogTrancode: false,
            newTransactionCode: ''
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        }
    },
    computed: {
        ...mapState({
            items: state => state.orderTransaction.all.data,
            total_rows: state => state.orderTransaction.all.total,
            loading: state => state.orderTransaction.loading,
        }),
        headers() {
            let dataType = configs.DATA_TYPE;
            const isFilter = this.adminRoles;
            return [
                {
                    text: "Mã vận đơn",
                    value: "OrderTransactionCode",
                    filterable: isFilter,
                    quickSearch: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Mã đơn CN",
                    value: "OrderCodeCN",
                    filterable: isFilter,
                    quickSearch: true,
                    dataType: dataType["String"]
                },
                {
                    text: "OrderID",
                    value: "OrderID",
                    quickSearch: isFilter,
                    filterable: isFilter,
                    dataType: dataType["Number"]
                },
                // {
                //     text: "Bao hàng",
                //     value: "PackageCode",
                //     quickSearch: isFilter,
                //     filterable: isFilter,
                //     dataType: dataType["String"]
                // },
                {
                    text: "Phiếu xuất",
                    value: "ExportReceiptID",
                    quickSearch: isFilter,
                    filterable: isFilter,
                    dataType: dataType["Number"]
                },
                {
                    text: "Khách hàng",
                    value: "Username",
                    filterable: isFilter,
                    dataType: dataType["String"]
                },
                {
                    text: "Thể tích",
                    value: "Volume",
                    align: "end",
                    filterable: isFilter,
                    dataType: dataType["Number"]
                },
                {
                    text: "Cân nặng",
                    value: "Weight",
                    align: "end",
                    filterable: isFilter,
                    dataType: dataType["Number"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: isFilter,
                    dataType: dataType["Enum"],
                    values: configs.PACKAGE_STATUS
                },
                {
                    text: "Ngày tạo",
                    value: "CreatedDate",
                    filterable: isFilter,
                    dataType: dataType["Date"]
                },
                {
                    text: "Thao tác",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ];
        },
        adminRoles() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Manager) == configs.ROLE_TYPE.Manager); 
        },
        weightEditable() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN); 
        },
        moduleRole() {
            return this.$store.state.authentication.role.Module;
        },
    },
    methods: {
        get_status_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        printTransaction(weight, transactionCode, customerName, orderId, numberOfCode) {
            print_transaction(weight, transactionCode, customerName, orderId, numberOfCode);
        },
        saveItem:_.debounce(
        function(item) {
            let data = {
                ...item
            };
            data.Type = "transaction";
            data.ModifiedBy = this.$store.state.authentication.user.username;
            // item.Status = data.Status = data.Weight > 0 ? configs.PACKAGE_STATUS_ENUM.DA_VE_VN : configs.PACKAGE_STATUS_ENUM.DANG_DI_CHUYEN;
            delete data.CreatedDate;
            delete data.CreatedBy;
            this.$store.dispatch("orderTransaction/postOrderTransaction", data);
        }, 500, {leading: false, trailing: true}),
        refreshData() {
            this.filter_data();
        },
        // Only admin can view table, staff need search by code
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("orderTransaction/getList", param);
        },
        gotoDetail: function (type, id, uid) {
            if (type) {
                let routeData = this.$router.resolve({
                    name: "DepositDetail",
                    params: {
                        Pid: id,
                        title: `Chi tiết đơn hàng (#${id})`
                    },
                    query: {
                        'uid': uid
                    }
                });
                window.open(routeData.href, "_blank");
            } else {
                let routeData = this.$router.resolve({
                    name: "OrderDetail",
                    params: {
                        Pid: id,
                        title: `Chi tiết đơn hàng (#${id})`
                    }
                });
                window.open(routeData.href, "_blank");
            }
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = {...configs.PAGINATION};
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        dialogTrancode() {
            this.showDialogTrancode = true;
        },
        saveNewTrancode(isCloseDialog = true) {
            if(this.newTransactionCode.indexOf('http') > -1) {
                sendErrorNotice('Mã vận đơn không đúng định dạng.');
                return;
            }
            if(this.newTransactionCode != '') {
                this.$store.dispatch("orderTransaction/setDetail", {'data': {'OrderTransactionCode': this.newTransactionCode, 'Action': 'import_trancode'}});
                this.newTransactionCode = '';
            }
            this.showDialogTrancode = !isCloseDialog;
        },
        bulk_delete() {
            window.getApp.$emit('REQUEST_BULK_DELETE', this.selectedList.map((item) => {return item.ID;}), 'transaction_code');
        }
    },
    mounted() {
        this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
        this.$root.$on("REQUEST_CREATE_DATA", this.dialogTrancode);
        this.$root.$on("PRE_BULK_DELETE", this.bulk_delete);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.refreshData);
        this.$root.$off("REQUEST_CREATE_DATA", this.dialogTrancode);
        this.$root.$off("PRE_BULK_DELETE", this.bulk_delete);
    }
};
</script>
